import i18nFactory from '@yandex-int/i18n';
import { FetchResult } from 'apollo-boost';
import { ApolloQueryResult } from 'apollo-client';
import { compact, findIndex, isEqual, some, values } from 'lodash';
import { Action } from 'redux';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { concat, EMPTY, forkJoin, from, Observable, of } from 'rxjs';
import { catchError, filter, first, map, mapTo, mergeMap, switchMap } from 'rxjs/operators';

import { closeCampaignPlaceEditorAction } from '../../actions/campaignPlaceEditor/closeCampaignPlaceEditor';
import { initCampaignPlaceEditorsAction } from '../../actions/campaignPlaceEditor/initCampaignPlaceEditors';
import {
    SAVE_CAMPAIGN_PLACE_EDITOR,
    SaveCampaignPlaceEditor
} from '../../actions/campaignPlaceEditor/saveCampaignPlaceEditor';
import { showErrorsCampaignPlaceEditorAction } from '../../actions/campaignPlaceEditor/showErrorsCampaignPlaceEditor';
import {
    ADD_END_DATE_FOR_EDIT_CAMPAIGNS,
    AddEndDateForEditCampaigns,
    CHANGE_CAMPAIGN_PRICE_PACKAGE_FOR_CAMPAIGNS_EDIT,
    CHANGE_SITE_MONITORING_FLAG_FOR_EDIT_CAMPAIGNS,
    ChangeCampaignPricePackageForEditCampaign,
    changeCampaignsEditPageStatus,
    changeNotificationsDisableValueForEditCampaigns,
    ChangeSiteMonitoringFlagForEditCampaigns,
    CREATE_CAMPAIGNS,
    createCampaigns,
    dailyBudgetOperationsMetrika,
    DELETE_END_DATE_FOR_EDIT_CAMPAIGNS,
    DeleteEndDateForEditCampaigns,
    FETCH_CAMPAIGN_AB_SEGMENTS,
    FETCH_CAMPAIGN_AB_SEGMENTS_FOR_NEW_CAMPAIGN,
    FETCH_CAMPAIGN_GOALS_FOR_STRATEGY,
    FETCH_CAMPAIGNS_GOALS_AVAILABLE_FOR_KEY_GOALS,
    FETCH_GOALS_AVAILABLE_FOR_KEY_GOALS_FOR_NEW_CAMPAIGNS,
    FETCH_METRO_STATIONS_FOR_EDIT_CAMPAIGNS,
    FETCH_RELEVANT_PHRASES_GOALS_FOR_EDIT_CAMPAIGNS,
    fetchCampaignABSegments,
    FetchCampaignABSegments,
    fetchCampaignABSegmentsForNewCampaign,
    FetchCampaignABSegmentsForNewCampaign,
    fetchCampaignGoalsForStrategy,
    FetchCampaignGoalsForStrategyAction,
    FetchCampaignsGoalsAvailableForKeyGoals,
    fetchCampaignsGoalsAvailableForKeyGoals,
    fetchGoalsAvailableForKeyGoalsForNewCampaigns,
    FetchGoalsAvailableForKeyGoalsForNewCampaigns,
    fetchMetroStationsForEditCampaigns,
    FetchMetroStationsForEditCampaigns,
    fetchRelevantPhrasesGoalsForEditCampaigns,
    FetchRelevantPhrasesGoalsForEditCampaigns,
    GET_CAMPAIGNS_FOR_EDIT,
    GET_DEFAULT_CAMPAIGNS_FOR_EDIT,
    GET_RETARGETING_CONDITIONS_FOR_CAMPAIGNS_EDIT,
    GetDefaultCampaignsForEditAction,
    GetRetargetingConditionsForCampaignsEditAction,
    LEAVE_CAMPAIGNS_EDIT,
    leaveCampaignsEdit,
    LeaveCampaignsEditAction,
    ON_DONE_CAMPAIGN_ALLOWED_PAGE_IDS_EDITOR,
    ON_DONE_CAMPAIGN_BANNED_DOMAINS_EDITOR,
    ON_DONE_CAMPAIGN_BANNED_VIDEO_DOMAINS_EDITOR,
    ON_DONE_CAMPAIGN_DISABLED_IPS_EDITOR,
    ON_DONE_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    OnDoneCampaignAllowedPageIdsEditorAction,
    OnDoneCampaignBannedDomainsEditorAction,
    OnDoneCampaignBannedVideoDomainsEditorAction,
    OnDoneCampaignDisabledIpsEditor,
    OnDoneCampaignRelevantPhrasesEditor,
    resetCampaignExperiments,
    SAVE_CAMPAIGN_CHAT_LIST_EDITOR,
    SAVE_CAMPAIGN_EXPERIMENTS_EDITOR,
    SAVE_CAMPAIGN_METRIKA_COUNTER_EDITOR,
    SAVE_CAMPAIGN_METRIKA_KEY_GOALS_EDITOR,
    SAVE_CAMPAIGN_MINUS_PHRASES_EDITOR,
    SAVE_CAMPAIGN_NAME_EDITOR_CHANGES,
    SAVE_CAMPAIGN_RATE_CORRECTIONS_EDITOR,
    SAVE_CAMPAIGNS,
    SAVE_NOTIFICATIONS_EDITOR_FOR_EDIT_CAMPAIGNS,
    SAVE_TIME_TARGETING_EDITOR_FOR_EDIT_CAMPAIGNS,
    SAVE_VISITING_CARD_FOR_EDIT_CAMPAIGN,
    SaveCampaignChatListEditorAction,
    SaveCampaignExperimentsEditorAction,
    SaveCampaignMetrikaCounterEditorAction,
    SaveCampaignMetrikaKeyGoalsEditorAction,
    SaveCampaignMinusPhrasesEditor,
    SaveCampaignNameEditorChangesAction,
    SaveCampaignRateCorrectionsEditorAction,
    saveCampaigns,
    SaveNotificationsEditorForEditCampaigns,
    SaveTimeTargetingEditorForEditCampaigns,
    SaveVisitingCardForEditCampaign,
    sendCreateCampaignMetrikaEvent,
    setMetrikaGoalsDataForStrategy,
    SetMetrikaGoalsDataForStrategyAction,
    showCampaignEditGeneralErrors,
    showCampaignEditGlobalError,
    showCampaignEditItemErrors,
    START_SAVE_CAMPAIGNS,
    synchronizeVisitingCardForEditCampaigns,
    toggleCampaignsOtherSettingsVisibilityAction,
    UPDATE_CAMPAIGN_METRIKA_COUNTERS,
    updateCampaignABSegmentsMetrikaUnavailable,
    updateCampaignABSegmentsSuccess,
    updateCampaignAllowedPageIdsValue,
    updateCampaignArchivedExperiments,
    UpdateCampaignAvailableForKeyGoals,
    updateCampaignAvailableForKeyGoals,
    updateCampaignBannedDomainsValue,
    updateCampaignBannedVideoDomainsValue,
    updateCampaignChat,
    updateCampaignDisabledIpsValue,
    updateCampaignExperiments,
    updateCampaignExperimentsRetargetingConditions,
    updateCampaignExperimentsValue,
    UpdateCampaignMetrikaCounters,
    updateCampaignMetrikaCounters,
    updateCampaignMetrikaKeyGoals,
    updateCampaignMetrikaMarkLinksFlag,
    updateCampaignMinusPhrases,
    updateCampaignName,
    updateCampaignNotifications,
    updateCampaignPlace,
    updateCampaignRateCorrections,
    updateCampaignRelevantPhrases,
    updateCampaignService,
    updateCampaignStrategy,
    updateCampaignTimeTargetingForEditCampaigns,
    updateDataForEditCampaigns,
    updateMetroStationsNameForEditCampaigns,
    updatePricePackagesForCampaignsEdit,
    updateRelevantPhrasesGoalsForEditCampaigns,
    updateRetargetingConditionsForCampaignsEdit
} from '../../actions/campaignsEdit';
import { closeCampaignServiceEditorAction } from '../../actions/campaignServiceEditor/closeCampaignServiceEditor';
import { initCampaignServiceEditorsAction } from '../../actions/campaignServiceEditor/initCampaignServiceEditors';
import {
    SAVE_CAMPAIGN_SERVICE_EDITOR,
    SaveCampaignServiceEditor
} from '../../actions/campaignServiceEditor/saveCampaignServiceEditor';
import { showErrorsCampaignServiceEditorAction } from '../../actions/campaignServiceEditor/showErrorsCampaignServiceEditor';
import { closeChatListEditor, fetchChatsChatListEditor } from '../../actions/chatList';
import { changeLocation, changeLocationHard, fetchTimeZoneGroups, updateMetroStations } from '../../actions/common';
import { updateDatesIntervalEditors } from '../../actions/datesIntervalEditor';
import {
    closeEditPageItemNameEditor,
    openEditPageItemNameEditor,
    showEditPageItemNameEditorErrors
} from '../../actions/editPageItemNameEditor';
import { closeExperimentsEditor, updateArchivedMapExperimentsEditor } from '../../actions/experimentsEditor';
import {
    closeItemsListTextareaEditor,
    updateItemsListEditorTextAreaErrors
} from '../../actions/itemsListTextareaEditor';
import {
    changeMarkLinksMetrikaCounterEditor,
    closeMetrikaCounterEditor,
    fetchCountersMetrikaCounterEditor,
    showMetrikaCounterEditorErrors
} from '../../actions/metrikaCounterEditor';
import {
    closeMetrikaKeyGoalsEditor,
    initMetrikaKeyGoalsEditors,
    resetMetrikaKeyGoalsEditorErrors,
    showMetrikaKeyGoalsEditorErrors,
    ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable,
    showMetrikaKeyGoalsEditorMetrikaIsUnavailable
} from '../../actions/metrikaKeyGoals';
import { closeMinusPhrasesEditor, showEditPageMinusPhrasesEditorErrors } from '../../actions/minusPhrasesEditor';
import {
    changeNotificationDisableValueForNotificationsEditor,
    closeNotificationsEditor,
    updateNotificationsEditorValidationData
} from '../../actions/notificationsEditor';
import { initOrganizationsEditors, updateOrganizationEditorErrors } from '../../actions/organizationsEditor';
import {
    FETCH_PRICE_PACKAGES_EDITOR,
    fetchPricePackagesEditor,
    FetchPricePackagesEditorAction
} from '../../actions/PricePackagesEditor';
import { updateRateCorrectionsEditorValidation } from '../../actions/rateCorrectionsEditor';
import {
    closeCampaignRelevantPhrasesEditor,
    initCampaignsRelevantPhrasesEditors,
    showRelevantPhrasesEditorErrors
} from '../../actions/relevantPhrases';
import { initShowsFrequencyEditors } from '../../actions/showsFrequency';
import {
    applyStrategyEditorValidationResult,
    ChangeStrategyGoalIdAction,
    clearRoiGoalIdError,
    closeStrategyEditor,
    hideRoiMeaningfulGoalsTooltip,
    initStrategyEditors,
    openStrategyEditor,
    StrategyEditorActionType,
    ValidateAndAttemptSaveAction
} from '../../actions/strategyEditor';
import {
    closeTimeTargetingEditor,
    updateValidationDataForTimeTargetingEditor
} from '../../actions/timeTargetingEditor';
import { closeVCardEditor, updateVisitingCardsErrors } from '../../actions/visitingCardEditor';
import { FetchMinusPhraseLibraryDataResult } from '../../api/MinusPhraseLibraryProvider/MinusPhraseLibraryProvider';
import { mapCampaignsDataForEditToInitPlaceData } from '../../mappers/campaignPlaceEditor';
import {
    getNotificationsValueFromNotificationsEditor,
    getTimeTargetingValueFromTimeTargetingEditor,
    mapABSegmentsQueryForNewCampaignResultToCampaignExperimentsValue,
    mapABSegmentsQueryResultToCampaignExperimentsValue,
    mapAddCampaignsDataToApiFormat,
    mapCampaignsDataForEditToInitKeyGoalsData,
    mapCampaignsDataForEditToInitRelevantPhrasesEditors,
    mapCampaignsDataToExperimentsConditionsRequestInput,
    mapCampaignsEditServerValidationResultToEditorsValidationResult,
    mapCampaignsForEditQueryResultToQueryResponse,
    mapCampaignsIdsToFetchBroadMatchGoalsInput,
    mapCampaignsIdsToFetchVisitingCardInput,
    mapCampaignsToFetchGoalsInput,
    mapDateEditorsDataFromPackageForCampaigns,
    mapDatesIntervalEditorsDataFromCampaigns,
    mapDatesIntervalRequiredEndDateEditorsDataFromCampaigns,
    mapDefaultCampaignsQueryResultToQueryResponse,
    mapGoalsByCounterIdsQueryResultToGoalsAvailableForKeyGoals,
    mapMeaningfulGoalsQueryResultToGoalsAvailableForKeyGoals,
    mapRetargetingConditionCampaignsEditFromApiFormat,
    mapUpdateCampaignsDataToApiFormat
} from '../../mappers/campaignsEdit/campaignsEdit';
import { mapDailyBudgetParamsForMetrikaFromCampaigns } from '../../mappers/campaignsEdit/strategy';
import { mapCampaignsDataForEditToInitServiceData } from '../../mappers/campaignServiceEditor';
import { mapChatListEditorValueToCampaignChatValue } from '../../mappers/chatListEditor/chatListEditor';
import { mapCampaignTypeTypeToApiCampaignType } from '../../mappers/common/common';
import {
    mapCreateExperimentsConditionsResult,
    mapEditorExperimentsToCampaignExperiments,
    mapExperimentsConditionValidationDataToUpdateArchivedExperimentsInput
} from '../../mappers/experimentsEditor';
import { mapMetrikaCountersEditorValueToCampaignMetrikaCountersValue } from '../../mappers/metrikaCounters';
import {
    mapFetchResultToLibraryItem,
    mapMinusPhrasesEditorValueToCampaignMinusPhrasesValue
} from '../../mappers/minusPhrases';
import {
    EntityType,
    mapCampaignsToOrganizationEditorParams,
    mapEntityIdToEditorKey
} from '../../mappers/organization/organization';
import { mapPricePackagesEditorData } from '../../mappers/pricePackages/pricePackages';
import { mapEditorRateCorrectionsToRateCorrections } from '../../mappers/rateCorrections/rateCorrections';
import { mapRelevantPhrasesEditorValueToCampaignRelevantPhrasesValue } from '../../mappers/relevantPhrases';
import { mapCampaignsDataForEditToInitShowsFrequencyData } from '../../mappers/showsFrequency';
import {
    mapCampaignsDataForEditToInitStrategyData,
    mapStrategyForCampaignData,
    mapStrategyGoalsDataForReducer,
    mapStrategyGoalsFromApiResponse
} from '../../mappers/strategyEditor';
import { awaitCommonData } from '../../operators';
import {
    getCampaignData,
    getCampaignValue,
    selectCampaignNotificationsValue,
    selectEditCampaignsConstants,
    selectPricePackageDataForEditCampaigns
} from '../../selectors/campaignsEdit/campaignsEdit';
import { selectEditPageItemNameEditorValue } from '../../selectors/editPageItemNameEditor/editPageItemNameEditor';
import { selectClientFeatures } from '../../selectors/groupEdit/group/group';
import { selectNotificationsEditorValue } from '../../selectors/notificationsEditor/notificationsEditor';
import { selectRelevantPhrasesEditorValue } from '../../selectors/relevantPhrasesEditor/relevantPhrasesEditor';
import { selectStrategyEditorConstsData } from '../../selectors/strategyEditor/strategyEditor';
import { selectTimeTargetingEditorValue } from '../../selectors/timeTargetingEditor/timeTargetingEditor';
import { areAllCampaignsReadOnly } from '../../service/CampaignHelpers/CampaignHelpers';
import {
    createCampaignsCreateErrorMapper,
    createCampaignsEditErrorMapper
} from '../../service/CampaignsEditHelpers/CampaignsEditBackErrorMapper/CampaignsEditBackErrorMapper';
import {
    getCampaignAllowedPageIdsEditorId,
    getCampaignBannedDomainsEditorId,
    getCampaignBannedVideoDomainsEditorId,
    getCampaignChatListEditorId,
    getCampaignDisabledIpsEditorId,
    getCampaignEditPageEditorId,
    getCampaignEditPageItemEditorId,
    getCampaignExperimentsEditorId,
    getCampaignMetrikaKeyGoalsEditorId,
    getCampaignMinusPhrasesEditorId,
    getCampaignPlaceEditorId,
    getCampaignsDataWithOpenedEditors,
    getCampaignServiceEditorId,
    getCampaignsIdsWithEnabledExperiments,
    getCampaignsIdsWithErrorsInAdditionalSettings,
    getCampaignStrategyEditorId,
    getEnabledFieldsFromAtLeastOneCampaign,
    isStrategyNeedsMarkMetrikaLinksEnabled,
    validateCampaignAllowedPageIdsEditor,
    validateCampaignBannedDomainsEditor,
    validateCampaignDisabledIpsEditor,
    validateCampaignMetrikaCountersEditor,
    validateCampaignNameEditor,
    validateCampaignPlace,
    validateCampaignRateCorrectionsEditor,
    validateCampaignRelevantPhrasesEditor,
    validateCampaignsEditEditors,
    validateCampaignService,
    validateMetrikaCampaignKeyGoalsEditor
} from '../../service/CampaignsEditHelpers/CampaignsEditHelpers';
import { confirm } from '../../service/Confirm/Confirm';
import { ApiMethodExecutingError, NotSyncedError } from '../../service/Errors';
import { createExperimentsConditionsErrorMapper } from '../../service/ExperimentsEditorHelpers/ExperimentsEditorErrorMapper/ExperimentsEditorErrorMapper';
import { getArchivedExperimentsCount } from '../../service/ExperimentsEditorHelpers/ExperimentsEditorHelpers';
import { fireCampaignsEditMetrika } from '../../service/Metrika/metrika';
import { validateNotificationsEditor } from '../../service/NotificationEditorHelper/NotificationEditorHelper';
import { EpicDeps } from '../../service/StoreFactory';
import { setRoiMeaningfulGoalsTooltipHidden } from '../../service/StrategyEditorHelpers/StrategyEditorHelpers';
import {
    isStrategyValidationResultPositive,
    validateStrategy
} from '../../service/StrategyEditorValidators/StrategyEditorValidators';
import { validateCampaignTimeTargetingEditor } from '../../service/TimeTargetingEditorHelper/TimeTargetingEditorHelper';
import { UrlHelpers } from '../../service/UrlHelpers';
import { MetroStationInfo } from '../../typings/banners';
import {
    CampaignsEditEditorsValidationResult,
    DataForEditCampaigns,
    EditCampaignEditor,
    EditCampaignsErrorsData,
    EditCampaignValueField,
    EnabledFieldsMap
} from '../../typings/campaignsEdit';
import { PageStatus } from '../../typings/common';
import { DnaEpic, DnaEpicAction } from '../../typings/epic';
import { ExperimentsConditionsValidationData } from '../../typings/experimentsEditor';
import { AdditionalGoalIds, GoalForStrategy } from '../../typings/goals';
import {
    AddCampaigns,
    BroadmatchGoalsQuery,
    FindOrCreateExperimentsConditions,
    FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_addedConditions,
    FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult,
    GdCreateRetargetingConditionForExperimentsItemInput,
    PricePackagesAvailableForClient,
    RetargetingConditionsQueryForCampaignsEdit,
    UpdateCampaigns
} from '../../typings/graphql-grid';
import { GroupsScreenUrlSearchQueryParams } from '../../typings/groups';
import { NotificationType } from '../../typings/notificationEditor';
import { OrganizationEditorParams } from '../../typings/organizations';
import { State } from '../../typings/state';

import * as keyset from './campaignsEdit.i18n';

const i18n = i18nFactory(keyset);

const initCampaignsEditors = (
    campaignsData: DataForEditCampaigns,
    enabledFieldsAtLeastOneCampaign: EnabledFieldsMap
): Action[] => {
    const datesIntervalEditorsData = mapDatesIntervalEditorsDataFromCampaigns(campaignsData);
    const hasUpdatesEditorsForDatesIntervalEditors = Object.keys(datesIntervalEditorsData).length > 0;

    const datesIntervalRequiredEndDateEditorsData = mapDatesIntervalRequiredEndDateEditorsDataFromCampaigns(
        campaignsData
    );
    const hasUpdatesEditorsForDatesIntervalRequiredEndDateEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.datesWithRequiredEndDate] &&
        Object.keys(datesIntervalRequiredEndDateEditorsData).length > 0;

    const strategyData = mapCampaignsDataForEditToInitStrategyData(campaignsData.campaigns);
    const hasStrategyEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.strategy] && strategyData.length > 0;

    const phrasesData = mapCampaignsDataForEditToInitRelevantPhrasesEditors(campaignsData.campaigns);
    const hasPhrasesEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.relevantPhrases] && phrasesData.length > 0;

    const keyGoalsData = mapCampaignsDataForEditToInitKeyGoalsData(campaignsData.campaigns);
    const hasKeyGoalsEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.metrikaKeyGoals] && keyGoalsData.length > 0;

    const organizations: OrganizationEditorParams[] = mapCampaignsToOrganizationEditorParams(campaignsData);
    const hasOrganizationsEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.organizationId] && organizations.length > 0;

    const showsFrequencyData = mapCampaignsDataForEditToInitShowsFrequencyData(campaignsData.campaigns);
    const hasShowsFrequencyEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.showsFrequency] && showsFrequencyData.length > 0;

    const campaignServiceData = mapCampaignsDataForEditToInitServiceData(campaignsData.campaigns);
    const hasCampaignServiceEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.service] && campaignServiceData.length > 0;

    const campaignPlaceData = mapCampaignsDataForEditToInitPlaceData(campaignsData.campaigns);
    const hasCampaignPlaceEditors =
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.place] && campaignPlaceData.length > 0;

    // в этот массив можно добавлять новые экшны инициализации редакторов страницы кампаний (должны зависеть от enabledFields)
    // сейчас редакторы обычно инициализируются на их раскрытие, поэтому сюда пока можно добавлять только редакторы,
    // которым необходима инициализация сразу при загрузки страницы с описанием причины в комментариях
    return compact([
        // редакторы дат должны быть проинициализированы сразу, так как они сразу открыты
        hasUpdatesEditorsForDatesIntervalEditors && updateDatesIntervalEditors(datesIntervalEditorsData),
        hasUpdatesEditorsForDatesIntervalRequiredEndDateEditors &&
            updateDatesIntervalEditors(datesIntervalRequiredEndDateEditorsData),
        // редактор ограничений показов должен быть проинициализирован сразу, так как он сразу открыт
        hasShowsFrequencyEditors && initShowsFrequencyEditors(showsFrequencyData),
        // редактор сервиса должен быть проинициализирован сразу, так как он сразу открыт
        hasCampaignServiceEditors && initCampaignServiceEditorsAction(campaignServiceData),
        // редактор плейса должен быть проинициализирован сразу, так как он сразу открыт
        hasCampaignPlaceEditors && initCampaignPlaceEditorsAction(campaignPlaceData),
        // необходимо инициализировать данными,
        // так как могут прийти невалидные данные от бэка и нам надо сразу показать ошибку
        hasStrategyEditors && initStrategyEditors(strategyData),
        // необходимо инициализировать данными,
        // так как могут прийти невалидные данные от бэка и нам надо сразу показать ошибку
        hasPhrasesEditors && initCampaignsRelevantPhrasesEditors(phrasesData),
        // необходимо инициализировать данными,
        // так как могут прийти невалидные данные от бэка и нам надо сразу показать ошибку
        hasKeyGoalsEditors && initMetrikaKeyGoalsEditors(keyGoalsData),
        // необходимо запросить данные организации,
        // так как они показываются и в закрытом состоянии редактора
        hasOrganizationsEditors && initOrganizationsEditors(organizations)
    ]);
};

const getCampaignsForEditEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_CAMPAIGNS_FOR_EDIT),
        awaitCommonData(action$, store$),
        mergeMap(
            (): DnaEpicAction => {
                const state = store$.value;
                const { login, constants } = state.commonData;
                if (constants === undefined) {
                    throw new Error('отсутсвует поле constants в commonData');
                }
                const { campaignsIds } = state.editCampaigns;

                if (campaignsIds.length === 0) {
                    const url = UrlHelpers.getCampaignListUrl();
                    return of(leaveCampaignsEdit(url, false));
                }

                return from(deps.campaignsDataProvider.getCampaigns(login, campaignsIds)).pipe(
                    mergeMap(
                        (campaignsResult): DnaEpicAction => {
                            const campaignsForEditData = mapCampaignsForEditQueryResultToQueryResponse(
                                campaignsResult,
                                constants,
                                selectClientFeatures(state)
                            );
                            const enabledFieldsAtLeastOneCampaign = getEnabledFieldsFromAtLeastOneCampaign(
                                campaignsForEditData.campaigns
                            );

                            return from(
                                getActionsForInitEditCampaignsPage(
                                    campaignsForEditData,
                                    enabledFieldsAtLeastOneCampaign
                                )
                            );
                        }
                    ),
                    catchError(
                        (err: Error | ApiMethodExecutingError): Observable<Action> => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            try {
                                fireCampaignsEditMetrika({
                                    getCampaignsForEdit: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            return of(
                                showCampaignEditGlobalError({
                                    title: i18n('page-common-error'),
                                    hint: message || i18n('page-common-error-hint')
                                })
                            );
                        }
                    )
                );
            }
        )
    );
};

const fetchCampaignsGoalsAvailableForKeyGoalsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_CAMPAIGNS_GOALS_AVAILABLE_FOR_KEY_GOALS),
        mergeMap(
            (action: FetchCampaignsGoalsAvailableForKeyGoals): DnaEpicAction => {
                const state = store$.value;
                const { fetchAvailableForKeyGoalsInput } = action;
                const {
                    commonData: { login }
                } = state;

                return from(
                    deps.campaignsDataProvider.getGoalsAvailableForKeyGoals(login, fetchAvailableForKeyGoalsInput)
                ).pipe(
                    mergeMap(
                        (result): DnaEpicAction => {
                            const {
                                campaignGoals: apiCampaignGoals,
                                isMetrikaAvailable
                            } = result.data.client.meaningfulGoals;

                            if (!isMetrikaAvailable) {
                                throw new Error('Метрика недоступна');
                            }

                            const campaignGoals = mapMeaningfulGoalsQueryResultToGoalsAvailableForKeyGoals(
                                apiCampaignGoals
                            );

                            return [updateCampaignAvailableForKeyGoals(isMetrikaAvailable, campaignGoals)];
                        }
                    ),
                    catchError((err: Error | ApiMethodExecutingError) => {
                        const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                        try {
                            fireCampaignsEditMetrika({
                                getGoalsAvailableForKeyGoals: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return Object.keys(state.metrikaKeyGoalsEditor).map(editorId => {
                            return showMetrikaKeyGoalsEditorMetrikaIsUnavailable(editorId);
                        });
                    })
                );
            }
        )
    );
};

const fetchGoalsAvailableForKeyGoalsForNewCampaignsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_GOALS_AVAILABLE_FOR_KEY_GOALS_FOR_NEW_CAMPAIGNS),
        mergeMap(
            (
                action: FetchGoalsAvailableForKeyGoalsForNewCampaigns
            ): Observable<UpdateCampaignAvailableForKeyGoals | ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable> => {
                const state = store$.value;
                const { countersIdsIn, campaignId } = action;
                const {
                    commonData: { login }
                } = state;

                return from(
                    deps.campaignsDataProvider.getGoalsAvailableForKeyGoalsForNewCampaign(login, countersIdsIn)
                ).pipe(
                    map(
                        (result): UpdateCampaignAvailableForKeyGoals => {
                            const {
                                goalsByCounterIds: { counterWithGoals, isMetrikaAvailable }
                            } = result.data.client;

                            if (!isMetrikaAvailable) {
                                throw new Error('Метрика недоступна');
                            }

                            const campaignGoals = mapGoalsByCounterIdsQueryResultToGoalsAvailableForKeyGoals(
                                counterWithGoals,
                                campaignId
                            );

                            return updateCampaignAvailableForKeyGoals(true, [campaignGoals]);
                        }
                    ),
                    catchError(
                        (err: Error | ApiMethodExecutingError): ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable[] => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            try {
                                fireCampaignsEditMetrika({
                                    getGoalsAvailableForKeyGoals: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }
                            return Object.keys(state.metrikaKeyGoalsEditor).map<
                                ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable
                            >(editorId => showMetrikaKeyGoalsEditorMetrikaIsUnavailable(editorId));
                        }
                    )
                );
            }
        )
    );
};

const fetchCampaignABSegmentsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_CAMPAIGN_AB_SEGMENTS),
        mergeMap(
            (action: FetchCampaignABSegments): DnaEpicAction => {
                const state = store$.value;
                const {
                    commonData: { login },
                    editCampaigns: { campaigns }
                } = state;

                const campaignsIdsWithEnabledExperiments = getCampaignsIdsWithEnabledExperiments(campaigns);

                if (campaignsIdsWithEnabledExperiments.length === 0) {
                    return EMPTY;
                }

                const isRetargetingConditionsFetchMetrikaAvailable = Object.keys(campaigns).every(campaignId => {
                    return campaigns[campaignId].abSegments.isMetrikaAvailable;
                });

                if (!isRetargetingConditionsFetchMetrikaAvailable) {
                    return [updateCampaignABSegmentsMetrikaUnavailable(campaignsIdsWithEnabledExperiments)];
                }

                const { fetchABSegmentsInput } = action;
                const campaignIds = fetchABSegmentsInput.map(input => input.campaignId);

                return from(deps.campaignsDataProvider.getCampaignsABSegments(login, fetchABSegmentsInput)).pipe(
                    mergeMap(
                        (result): DnaEpicAction => {
                            const { abSegments } = result.data.client;

                            if (abSegments === null) {
                                throw new Error('Получение А/Б сегментов недоступно для клиента');
                            }

                            const { campaignGoals: apiCampaignGoals, isMetrikaAvailable } = abSegments;

                            if (!isMetrikaAvailable) {
                                throw new Error('Метрика недоступна');
                            }

                            return [
                                updateCampaignABSegmentsSuccess(campaignIds),
                                updateCampaignExperimentsValue(
                                    mapABSegmentsQueryResultToCampaignExperimentsValue(apiCampaignGoals, campaigns)
                                )
                            ];
                        }
                    ),
                    catchError((err: Error | ApiMethodExecutingError) => {
                        const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                        try {
                            fireCampaignsEditMetrika({
                                getCampaignsABSegments: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return [updateCampaignABSegmentsMetrikaUnavailable(campaignIds)];
                    })
                );
            }
        )
    );
};

const fetchCampaignABSegmentsForNewCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_CAMPAIGN_AB_SEGMENTS_FOR_NEW_CAMPAIGN),
        mergeMap(
            (action: FetchCampaignABSegmentsForNewCampaign): DnaEpicAction => {
                const state = store$.value;
                const {
                    commonData: { login },
                    editCampaigns: { campaigns }
                } = state;
                const { campaignId, countersIds } = action;
                const campaign = campaigns[campaignId];

                if (!campaign.enabledFields.experiments) {
                    return EMPTY;
                }

                return from(deps.campaignsDataProvider.getCampaignsABSegmentsForNewCampaign(login, countersIds)).pipe(
                    mergeMap(
                        (result): DnaEpicAction => {
                            const { abSegmentsByCounterIds } = result.data.client;

                            if (abSegmentsByCounterIds === null) {
                                throw new Error('Получение А/Б сегментов недоступно для клиента');
                            }

                            const { counterWithGoals, isMetrikaAvailable } = abSegmentsByCounterIds;

                            if (!isMetrikaAvailable) {
                                throw new Error('Метрика недоступна');
                            }

                            return [
                                updateCampaignABSegmentsSuccess([campaignId]),
                                updateCampaignExperimentsValue(
                                    mapABSegmentsQueryForNewCampaignResultToCampaignExperimentsValue(
                                        campaignId,
                                        counterWithGoals,
                                        campaigns
                                    )
                                )
                            ];
                        }
                    ),
                    catchError((err: Error | ApiMethodExecutingError) => {
                        const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                        try {
                            fireCampaignsEditMetrika({
                                getCampaignsABSegments: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return [updateCampaignABSegmentsMetrikaUnavailable([campaignId])];
                    })
                );
            }
        )
    );
};

const saveCampaignChatEpic: DnaEpic = (action$, store, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_CHAT_LIST_EDITOR),
        switchMap(
            (action: SaveCampaignChatListEditorAction): DnaEpicAction => {
                const { campaignId } = action;
                const {
                    chatListEditor: { editors }
                } = store.value;
                const editorId = getCampaignChatListEditorId(campaignId);

                return [
                    updateCampaignChat(campaignId, mapChatListEditorValueToCampaignChatValue(editors[editorId])),
                    closeChatListEditor(editorId)
                ];
            }
        )
    );
};

const getCampaignsEditEditorsShowErrorsActions = (errorsData: CampaignsEditEditorsValidationResult[]): Action[] => {
    return errorsData.reduce((res: Action[], errorData: CampaignsEditEditorsValidationResult) => {
        let actions: Action[] = [];
        const { campaignId } = errorData;
        const editorId = getCampaignEditPageItemEditorId(campaignId);

        switch (errorData.editor) {
            case EditCampaignEditor.nameEditor:
                actions = [showEditPageItemNameEditorErrors(editorId, errorData.errors)];
                break;

            case EditCampaignEditor.disabledIpsEditor:
                actions = [
                    updateItemsListEditorTextAreaErrors(getCampaignDisabledIpsEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.bannedDomainsEditor:
                actions = [
                    updateItemsListEditorTextAreaErrors(getCampaignBannedDomainsEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.allowedPageIdsEditor:
                actions = [
                    updateItemsListEditorTextAreaErrors(getCampaignAllowedPageIdsEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.relevantPhrasesEditor:
                actions = [showRelevantPhrasesEditorErrors(editorId, errorData.errors)];
                break;

            case EditCampaignEditor.notificationsEditor:
                actions = [updateNotificationsEditorValidationData(editorId, errorData.errors)];
                break;

            case EditCampaignEditor.rateCorrectionsEditor:
                actions = [updateRateCorrectionsEditorValidation(editorId, errorData.errors)];
                break;

            case EditCampaignEditor.strategyEditor:
                actions = [
                    applyStrategyEditorValidationResult(getCampaignStrategyEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.serviceEditor:
                actions = [
                    showErrorsCampaignServiceEditorAction(getCampaignServiceEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.placeEditor:
                actions = [showErrorsCampaignPlaceEditorAction(getCampaignPlaceEditorId(campaignId), errorData.errors)];
                break;

            case EditCampaignEditor.metrikaCounterEditor:
                actions = [
                    showMetrikaCounterEditorErrors(getCampaignEditPageItemEditorId(campaignId), errorData.errors)
                ];
                break;

            case EditCampaignEditor.timeTargetingEditor:
                actions = [updateValidationDataForTimeTargetingEditor(campaignId, errorData.errors)];
                break;

            case EditCampaignEditor.metrikaKeyGoalsEditor:
                actions = [
                    showMetrikaKeyGoalsEditorErrors(
                        getCampaignMetrikaKeyGoalsEditorId(campaignId),
                        errorData.keyGoalsValidationData
                    )
                ];
                break;

            case EditCampaignEditor.bannersLanguage:
                actions = [
                    showCampaignEditItemErrors(campaignId, EditCampaignValueField.bannersLanguage, errorData.errors)
                ];
                break;

            case EditCampaignEditor.minusPhrases: {
                actions = [
                    showEditPageMinusPhrasesEditorErrors(
                        getCampaignMinusPhrasesEditorId(campaignId),
                        errorData.errors,
                        []
                    )
                ];

                break;
            }

            case EditCampaignEditor.visitingCardEditor:
                actions = [updateVisitingCardsErrors(getCampaignEditPageItemEditorId(campaignId), errorData.errors)];
                break;

            case EditCampaignEditor.organization:
                actions = [
                    updateOrganizationEditorErrors(
                        mapEntityIdToEditorKey(campaignId, EntityType.campaign),
                        errorData.errors
                    )
                ];
                break;

            case 'general':
                actions = [showCampaignEditItemErrors(campaignId, 'general', errorData.errors)];
                break;

            default:
                break;
        }

        return [...res, ...actions];
    }, []);
};

const startSaveCampaignsEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(START_SAVE_CAMPAIGNS),
        switchMap(
            (): DnaEpicAction => {
                const state = store$.value;

                const {
                    editCampaigns: { isCreatePage }
                } = state;

                const saveAction = isCreatePage ? of(createCampaigns()) : of(saveCampaigns());

                const editorsErrors = validateCampaignsEditEditors(state);
                if (editorsErrors.length !== 0) {
                    return from([
                        changeCampaignsEditPageStatus(PageStatus.LOADED),
                        toggleCampaignsOtherSettingsVisibilityAction(
                            getCampaignsIdsWithErrorsInAdditionalSettings(editorsErrors)
                        ),
                        ...getCampaignsEditEditorsShowErrorsActions(editorsErrors)
                    ]);
                }

                const campaignsValue = getCampaignsDataWithOpenedEditors(state);
                const campaignIds = Object.keys(campaignsValue);

                const campaignsIdsWithEnabledExperiments = getCampaignsIdsWithEnabledExperiments(campaignsValue);

                const experimentsConditionsItems = mapCampaignsDataToExperimentsConditionsRequestInput(
                    campaignIds,
                    campaignsValue
                );

                return forkJoin([
                    // здесь описывается все что нужно сделать до сохранения кампаний

                    // Для сохранения экспериментов, необходимо запросить в отдельной ручке
                    // abSegmentRetargetingConditionId и abSegmentStatisticRetargetingConditionId
                    saveExperimentsConditionsForEditCampaignRequest(state, deps, experimentsConditionsItems)
                ]).pipe(
                    mergeMap(
                        ([responseExperimentsConditions]): DnaEpicAction => {
                            if (responseExperimentsConditions === undefined) {
                                return EMPTY;
                            }

                            const { data, errors } = responseExperimentsConditions;
                            if (data === undefined || (errors !== undefined && errors.length !== 0)) {
                                throw new Error();
                            }

                            const { addedConditions, validationResult } = data.findOrCreateExperimentsConditions;
                            if (addedConditions === null) {
                                if (validationResult === null) {
                                    throw new Error();
                                }

                                return saveExperimentsConditionsForEditCampaignErrorExecutor(
                                    validationResult,
                                    campaignsIdsWithEnabledExperiments,
                                    experimentsConditionsItems
                                );
                            }

                            return concat(
                                saveExperimentsConditionsForEditCampaignSuccessExecutor(
                                    campaignsIdsWithEnabledExperiments,
                                    addedConditions
                                ),
                                saveAction
                            );
                        }
                    ),
                    catchError(err => {
                        const message =
                            err instanceof ApiMethodExecutingError
                                ? err.getMessage()
                                : err.message || i18n('save-campaigns-error');

                        try {
                            fireCampaignsEditMetrika({
                                startUpdateCampaigns: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return of(
                            showCampaignEditGeneralErrors([
                                {
                                    text: message
                                }
                            ]),
                            changeCampaignsEditPageStatus(PageStatus.LOADED)
                        );
                    })
                );
            }
        )
    );
};

const saveCampaignsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGNS),
        mergeMap(
            (): DnaEpicAction => {
                const state = store$.value;
                const {
                    commonData: { login },
                    editCampaigns: { campaignsIds, constants }
                } = state;

                if (constants === undefined) {
                    throw Error();
                }
                const campaignsValue = getCampaignsDataWithOpenedEditors(state);
                return from(
                    deps.campaignsMutationExecutor.updateCampaigns(
                        mapUpdateCampaignsDataToApiFormat(campaignsValue, constants),
                        login
                    )
                ).pipe(
                    switchMap(
                        (response: FetchResult<UpdateCampaigns>): DnaEpicAction => {
                            const responseData = response.data;

                            try {
                                fireCampaignsEditMetrika({
                                    updateCampaigns: {
                                        responseData: JSON.stringify(responseData)
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            if (responseData === undefined || responseData.updateCampaigns === undefined) {
                                throw Error();
                            }

                            const updateCampaignsServerErrors =
                                (responseData.updateCampaigns.validationResult &&
                                    responseData.updateCampaigns.validationResult.errors) ||
                                [];

                            if (updateCampaignsServerErrors.length !== 0) {
                                const updateCampaignsErrorMapper = createCampaignsEditErrorMapper(campaignsIds);

                                const updateCampaignsErrorsData = updateCampaignsErrorMapper.mapServerErrorsToClientError(
                                    updateCampaignsServerErrors
                                ) as EditCampaignsErrorsData;

                                const editorsErrorsData = mapCampaignsEditServerValidationResultToEditorsValidationResult(
                                    updateCampaignsErrorsData
                                );

                                return from(getListActionsAfterSaveCampaignsWithErrorsValidation(editorsErrorsData));
                            }

                            const url = UrlHelpers.getCampaignListUrl();

                            return [
                                ...mapDailyBudgetParamsForMetrikaFromCampaigns(campaignsValue).map(
                                    dailyBudgetOperationsMetrika
                                ),
                                leaveCampaignsEdit(url, false)
                            ];
                        }
                    ),
                    catchError((error: Error | ApiMethodExecutingError | NotSyncedError<UpdateCampaigns>): Action[] => {
                        if (error instanceof NotSyncedError) {
                            return [changeCampaignsEditPageStatus(PageStatus.LOADED)];
                        }

                        const message =
                            error instanceof ApiMethodExecutingError
                                ? error.getMessage()
                                : error.message || i18n('save-campaigns-error');

                        try {
                            fireCampaignsEditMetrika({
                                updateCampaigns: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return [
                            showCampaignEditGeneralErrors([
                                {
                                    text: message
                                }
                            ]),
                            changeCampaignsEditPageStatus(PageStatus.LOADED)
                        ];
                    })
                );
            }
        )
    );
};

const getListActionsAfterSaveCampaignsWithErrorsValidation = (
    editorsErrorsData: CampaignsEditEditorsValidationResult[]
) => {
    return [
        changeCampaignsEditPageStatus(PageStatus.LOADED),
        toggleCampaignsOtherSettingsVisibilityAction(getCampaignsIdsWithErrorsInAdditionalSettings(editorsErrorsData)),
        ...getCampaignsEditEditorsShowErrorsActions(editorsErrorsData)
    ];
};

const createCampaignsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(CREATE_CAMPAIGNS),
        mergeMap(
            (): DnaEpicAction => {
                const state = store$.value;

                const editorsErrors = validateCampaignsEditEditors(state);
                const {
                    commonData: { login },
                    editCampaigns: { campaigns, constants }
                } = state;
                const campaignsIds = Object.keys(campaigns);

                if (constants === undefined) {
                    throw Error();
                }

                if (editorsErrors.length !== 0) {
                    return [
                        changeCampaignsEditPageStatus(PageStatus.LOADED),
                        ...getCampaignsEditEditorsShowErrorsActions(editorsErrors)
                    ];
                }

                const campaignsValue = getCampaignsDataWithOpenedEditors(state);

                return concat(
                    of(sendCreateCampaignMetrikaEvent(campaignsValue[campaignsIds[0]])),
                    from(
                        deps.campaignsMutationExecutor.addCampaigns(
                            mapAddCampaignsDataToApiFormat(campaignsValue, constants),
                            login
                        )
                    ).pipe(
                        switchMap((response: FetchResult<AddCampaigns>) => {
                            const responseData = response.data;

                            if (responseData === undefined || responseData.addCampaigns === undefined) {
                                throw Error();
                            }

                            const addCampaignsServerErrors =
                                (responseData.addCampaigns.validationResult &&
                                    responseData.addCampaigns.validationResult.errors) ||
                                [];

                            if (addCampaignsServerErrors.length !== 0) {
                                const addCampaignsErrorMapper = createCampaignsCreateErrorMapper(campaignsIds);

                                const addCampaignsErrorsData = addCampaignsErrorMapper.mapServerErrorsToClientError(
                                    addCampaignsServerErrors
                                ) as EditCampaignsErrorsData;

                                const editorsErrorsData = mapCampaignsEditServerValidationResultToEditorsValidationResult(
                                    addCampaignsErrorsData
                                );

                                return from(getListActionsAfterSaveCampaignsWithErrorsValidation(editorsErrorsData));
                            }

                            const addedCampaignIds = responseData.addCampaigns.addedCampaigns.reduce(
                                (acc: string[], addedCampaign) => {
                                    if (addedCampaign !== null) {
                                        acc.push(addedCampaign.id);
                                    }

                                    return acc;
                                },
                                []
                            );

                            return of(
                                changeLocation(
                                    UrlHelpers.getGroupsEditUrl({
                                        [GroupsScreenUrlSearchQueryParams.campaignsIds]: addedCampaignIds,
                                        [GroupsScreenUrlSearchQueryParams.groupsIds]: [],
                                        [GroupsScreenUrlSearchQueryParams.ulogin]: login,
                                        [GroupsScreenUrlSearchQueryParams.isNew]: '1',
                                        [GroupsScreenUrlSearchQueryParams.isNewEmptyGroup]: '1'
                                    }),
                                    undefined,
                                    false
                                )
                            );
                        }),
                        catchError((error: Error | ApiMethodExecutingError | NotSyncedError<UpdateCampaigns>) => {
                            if (error instanceof NotSyncedError) {
                                return [changeCampaignsEditPageStatus(PageStatus.LOADED)];
                            }

                            const message =
                                error instanceof ApiMethodExecutingError
                                    ? error.getMessage()
                                    : error.message || i18n('save-campaigns-error');

                            try {
                                fireCampaignsEditMetrika({
                                    addCampaigns: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            return [
                                showCampaignEditGeneralErrors([
                                    {
                                        text: message
                                    }
                                ]),
                                changeCampaignsEditPageStatus(PageStatus.LOADED)
                            ];
                        })
                    )
                );
            }
        )
    );
};

const leaveCampaignsEditEpic: DnaEpic = (action$, store$) => {
    return action$.pipe(
        ofType(LEAVE_CAMPAIGNS_EDIT),
        switchMap(
            (action: LeaveCampaignsEditAction): Observable<Action> => {
                const state = store$.value;
                const { fromOldInterface, login } = state.commonData;
                const { campaignsIds, isCreatePage } = state.editCampaigns;
                const campaignsValue = getCampaignsDataWithOpenedEditors(state);
                const isReadOnly = areAllCampaignsReadOnly(campaignsValue);

                const wasDataChanged = some(campaignsValue, campaign => {
                    return !isEqual(campaign.value, campaign.serverValue);
                });

                let leaveAction: Action;

                if (!fromOldInterface) {
                    const { location } = action;
                    const locationParams =
                        typeof location === 'string'
                            ? {
                                  pathName: location,
                                  query: { ulogin: state.commonData.login }
                              }
                            : {
                                  pathName: location.pathname,
                                  query: location.query
                              };

                    leaveAction = changeLocation(locationParams.pathName, locationParams.query);
                } else {
                    const retpath = state.router.query && state.router.query.retpath;
                    const oldInterfaceUrl = UrlHelpers.getRedirectUrlFromRetpath(
                        retpath,
                        isCreatePage
                            ? UrlHelpers.getOldCampaignListUrl(login)
                            : UrlHelpers.getShowCampaignUrl(campaignsIds[0], login)
                    );

                    leaveAction = changeLocationHard(oldInterfaceUrl);
                }

                if (!isReadOnly && wasDataChanged && action.showConfirm) {
                    return from(
                        confirm({
                            message: i18n('warning-about-changes')
                        })
                    ).pipe(
                        switchMap(() => of(leaveAction)),
                        catchError(() => EMPTY)
                    );
                }

                return of(leaveAction);
            }
        )
    );
};

const getRetargetingConditionsForCampaignsEditEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_RETARGETING_CONDITIONS_FOR_CAMPAIGNS_EDIT),
        awaitCommonData(action$, store$),
        mergeMap(
            (action: GetRetargetingConditionsForCampaignsEditAction): Observable<Action> => {
                return from(deps.campaignsDataProvider.getRetargetingConditions(action.login)).pipe(
                    mergeMap(
                        (
                            retargetingResult: ApolloQueryResult<RetargetingConditionsQueryForCampaignsEdit>
                        ): Observable<Action> => {
                            const retargetingConditions = retargetingResult.data.client.retargetingConditions.rowset;

                            return of(
                                updateRetargetingConditionsForCampaignsEdit(
                                    retargetingConditions.map(mapRetargetingConditionCampaignsEditFromApiFormat)
                                )
                            );
                        }
                    ),
                    catchError(
                        (err: Error | ApiMethodExecutingError): Observable<Action> => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            try {
                                fireCampaignsEditMetrika({
                                    getRetargetingConditions: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            return of(updateRetargetingConditionsForCampaignsEdit([]));
                        }
                    )
                );
            }
        )
    );
};

const saveCampaignRelevantPhrasesEpic: DnaEpic = (action$, store, deps) => {
    return action$.pipe(
        ofType(ON_DONE_CAMPAIGN_RELEVANT_PHRASES_EDITOR),
        mergeMap(
            (action: OnDoneCampaignRelevantPhrasesEditor): Observable<Action> => {
                const state = store.value;
                const { campaignId } = action;
                const editorId = getCampaignEditPageItemEditorId(campaignId);

                const { isValid, errors } = validateCampaignRelevantPhrasesEditor(campaignId, state);

                if (!isValid) {
                    return of(showRelevantPhrasesEditorErrors(editorId, errors));
                }

                return of(
                    updateCampaignRelevantPhrases(
                        campaignId,
                        mapRelevantPhrasesEditorValueToCampaignRelevantPhrasesValue(
                            selectRelevantPhrasesEditorValue(state, editorId)
                        )
                    ),
                    closeCampaignRelevantPhrasesEditor(editorId)
                );
            }
        )
    );
};

const saveCampaignMetrikaCountersEpic: DnaEpic = (action$, store, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_METRIKA_COUNTER_EDITOR),
        switchMap((action: SaveCampaignMetrikaCounterEditorAction): Action[] => {
            const { campaignId } = action;
            const {
                metrikaCounterEditor,
                editCampaigns: { campaigns, isCreatePage }
            } = store.value;
            const editorId = getCampaignEditPageItemEditorId(campaignId);
            const experimentEditorId = getCampaignExperimentsEditorId(campaignId);
            const keyGoalsEditorId = getCampaignMetrikaKeyGoalsEditorId(campaignId);

            const newCountersValue = mapMetrikaCountersEditorValueToCampaignMetrikaCountersValue(
                metrikaCounterEditor.editors[editorId]
            );

            const errors = validateCampaignMetrikaCountersEditor(campaignId, store.value);

            if (errors.length !== 0) {
                return [showMetrikaCounterEditorErrors(editorId, errors)];
            }

            const fetchABSegmentsAction = isCreatePage
                ? fetchCampaignABSegmentsForNewCampaign(newCountersValue.counters, campaignId)
                : fetchCampaignABSegments(
                      mapCampaignsToFetchGoalsInput(
                          campaigns,
                          EditCampaignValueField.experiments,
                          newCountersValue.counters
                      )
                  );

            return [
                fetchABSegmentsAction,
                closeExperimentsEditor(experimentEditorId),
                resetCampaignExperiments(campaignId),
                resetMetrikaKeyGoalsEditorErrors(keyGoalsEditorId),
                updateCampaignMetrikaCounters(campaignId, newCountersValue),
                closeMetrikaCounterEditor(editorId)
            ];
        })
    );
};

const updateCampaignMetrikaCountersEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(UPDATE_CAMPAIGN_METRIKA_COUNTERS),
        switchMap(
            (action: UpdateCampaignMetrikaCounters): DnaEpicAction => {
                const {
                    editCampaigns: { isCreatePage },
                    metrikaCounterEditor: { counters: availableCounters }
                } = store$.value;
                const {
                    campaignId,
                    metrikaCounters: { counters }
                } = action;
                const availableCountersSet = new Set(availableCounters);

                const listActions: Action[] = [
                    fetchCampaignGoalsForStrategy(
                        {
                            [campaignId]: counters.filter(counter => availableCountersSet.has(counter))
                        },
                        isCreatePage
                    )
                ];

                if (isCreatePage) {
                    listActions.push(fetchGoalsAvailableForKeyGoalsForNewCampaigns(counters, campaignId));
                } else {
                    listActions.push(
                        fetchCampaignsGoalsAvailableForKeyGoals([
                            {
                                campaignId,
                                counterIds: counters
                            }
                        ])
                    );
                }

                return listActions;
            }
        )
    );
};

const updateCampaignNameEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_NAME_EDITOR_CHANGES),
        switchMap((action: SaveCampaignNameEditorChangesAction): Action[] => {
            const { campaignId } = action;
            const state = store$.value;
            const { editPageItemNameEditor } = state;
            const editorId = getCampaignEditPageEditorId(campaignId);
            const nameEditorData = selectEditPageItemNameEditorValue(editPageItemNameEditor, editorId);

            const nameValidationErrors = validateCampaignNameEditor(campaignId, state);

            if (nameValidationErrors.length === 0) {
                return [updateCampaignName(campaignId, nameEditorData.value), closeEditPageItemNameEditor(editorId)];
            }

            return [showEditPageItemNameEditorErrors(editorId, nameValidationErrors)];
        })
    );
};

const saveCampaignNotificationEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_NOTIFICATIONS_EDITOR_FOR_EDIT_CAMPAIGNS),
        switchMap((action: SaveNotificationsEditorForEditCampaigns): Action[] => {
            const state = store$.value;
            const {
                commonData: { constants }
            } = state;
            const editorId = getCampaignEditPageEditorId(action.campaignId);
            const notificationEditorState = selectNotificationsEditorValue(state, editorId);

            const validationData = validateNotificationsEditor(notificationEditorState, constants);

            if (!validationData.isValid) {
                return [updateNotificationsEditorValidationData(editorId, validationData)];
            }

            const campaignDataFromNotificationEditor = getNotificationsValueFromNotificationsEditor(
                notificationEditorState
            );

            return [
                updateCampaignNotifications(action.campaignId, campaignDataFromNotificationEditor),
                closeNotificationsEditor(editorId)
            ];
        })
    );
};

const saveCampaignTimeTargetingEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_TIME_TARGETING_EDITOR_FOR_EDIT_CAMPAIGNS),
        switchMap((action: SaveTimeTargetingEditorForEditCampaigns): Action[] => {
            const { campaignId } = action;
            const state = store$.value;
            const timeTargetingEditor = selectTimeTargetingEditorValue(state, campaignId);
            const campaignDataFromTimeTargetingEditor = getTimeTargetingValueFromTimeTargetingEditor(
                timeTargetingEditor
            );

            const errorsValidation = validateCampaignTimeTargetingEditor(campaignId, state);

            if (Object.keys(errorsValidation).length > 0) {
                return [updateValidationDataForTimeTargetingEditor(campaignId, errorsValidation)];
            }

            return [
                updateCampaignTimeTargetingForEditCampaigns(campaignId, campaignDataFromTimeTargetingEditor),
                closeTimeTargetingEditor(campaignId)
            ];
        })
    );
};

const updateCampaignDisabledIpsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_DONE_CAMPAIGN_DISABLED_IPS_EDITOR),
        switchMap((action: OnDoneCampaignDisabledIpsEditor): Action[] => {
            const { campaignId } = action;
            const state = store$.value;
            const editorId = getCampaignDisabledIpsEditorId(campaignId);

            const validationErrors = validateCampaignDisabledIpsEditor(campaignId, state);

            if (validationErrors.length === 0) {
                return [
                    updateCampaignDisabledIpsValue(campaignId, action.value),
                    closeItemsListTextareaEditor(editorId)
                ];
            }

            return [updateItemsListEditorTextAreaErrors(editorId, validationErrors)];
        })
    );
};

const updateCampaignBannedDomainsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_DONE_CAMPAIGN_BANNED_DOMAINS_EDITOR),
        switchMap((action: OnDoneCampaignBannedDomainsEditorAction): Action[] => {
            const { campaignId } = action;
            const state = store$.value;
            const editorId = getCampaignBannedDomainsEditorId(campaignId);
            const { maxBannedDomainsCount } = selectEditCampaignsConstants(state);

            const validationErrors = validateCampaignBannedDomainsEditor(campaignId, state, maxBannedDomainsCount);

            if (validationErrors.length !== 0) {
                return [updateItemsListEditorTextAreaErrors(editorId, validationErrors)];
            }

            return [updateCampaignBannedDomainsValue(campaignId, action.value), closeItemsListTextareaEditor(editorId)];
        })
    );
};

const updateCampaignBannedVideoDomainsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_DONE_CAMPAIGN_BANNED_VIDEO_DOMAINS_EDITOR),
        switchMap((action: OnDoneCampaignBannedVideoDomainsEditorAction): Action[] => {
            const { campaignId } = action;
            const state = store$.value;
            const editorId = getCampaignBannedVideoDomainsEditorId(campaignId);
            const { maxBannedVideoDomainsCount } = selectEditCampaignsConstants(state);

            const validationErrors = validateCampaignBannedDomainsEditor(campaignId, state, maxBannedVideoDomainsCount);

            if (validationErrors.length !== 0) {
                return [updateItemsListEditorTextAreaErrors(editorId, validationErrors)];
            }

            return [
                updateCampaignBannedVideoDomainsValue(campaignId, action.value),
                closeItemsListTextareaEditor(editorId)
            ];
        })
    );
};

const updateCampaignAllowedPageIdsEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_DONE_CAMPAIGN_ALLOWED_PAGE_IDS_EDITOR),
        switchMap((action: OnDoneCampaignAllowedPageIdsEditorAction): Action[] => {
            const state = store$.value;
            const { campaignId } = action;
            const editorId = getCampaignAllowedPageIdsEditorId(campaignId);

            const validationErrors = validateCampaignAllowedPageIdsEditor(campaignId, state);

            if (validationErrors.length > 0) {
                return [updateItemsListEditorTextAreaErrors(editorId, validationErrors)];
            } else {
                return [
                    updateCampaignAllowedPageIdsValue(campaignId, action.value),
                    closeItemsListTextareaEditor(editorId)
                ];
            }
        })
    );
};

const saveCampaignExperimentsEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_EXPERIMENTS_EDITOR),
        mergeMap(
            (action: SaveCampaignExperimentsEditorAction): Observable<Action> => {
                const { campaignId } = action;
                const editorId = getCampaignExperimentsEditorId(campaignId);
                const state = store$.value;
                const experimentsEditorState = state.experimentsEditor[editorId];
                const experimentsValue =
                    state.editCampaigns.campaigns[campaignId].value[EditCampaignValueField.experiments];

                const activeArchivedExperimentsCount = getArchivedExperimentsCount(
                    experimentsEditorState.archivedExperimentsMap
                );

                if (activeArchivedExperimentsCount !== 0) {
                    return EMPTY;
                }

                if (experimentsEditorState.areCorrectionsEnabled) {
                    const hasErrors = values(experimentsEditorState.correctionsMap).some(correctionItem => {
                        return correctionItem.errors.length !== 0;
                    });

                    if (hasErrors) {
                        return EMPTY;
                    }
                }

                return from([
                    updateCampaignExperiments(
                        campaignId,
                        mapEditorExperimentsToCampaignExperiments(experimentsEditorState, experimentsValue)
                    ),
                    closeExperimentsEditor(editorId)
                ]);
            }
        )
    );
};

const saveCampaignMetrikaKeyGoalsEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_METRIKA_KEY_GOALS_EDITOR),
        switchMap((action: SaveCampaignMetrikaKeyGoalsEditorAction): Action[] | Observable<Action> => {
            const state = store$.value;
            const { campaignId } = action;
            const editorId = getCampaignMetrikaKeyGoalsEditorId(campaignId);

            const { isValid, keyGoalsValidationData } = validateMetrikaCampaignKeyGoalsEditor(campaignId, state);

            if (isValid) {
                return [
                    updateCampaignMetrikaKeyGoals(campaignId, state.metrikaKeyGoalsEditor[editorId].selectedGoals),
                    closeMetrikaKeyGoalsEditor(editorId),
                    clearRoiGoalIdError(getCampaignStrategyEditorId(campaignId))
                ];
            }

            return [showMetrikaKeyGoalsEditorErrors(editorId, keyGoalsValidationData)];
        })
    );
};

const saveCampaignRateCorrectionEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_RATE_CORRECTIONS_EDITOR),
        switchMap((action: SaveCampaignRateCorrectionsEditorAction) => {
            const state = store$.value;
            const { editorId, campaignId } = action;
            const editorState = state.rateCorrectionsEditor[editorId].value;

            const validationResult = validateCampaignRateCorrectionsEditor(campaignId, state);

            if (validationResult.isValid) {
                return [
                    updateRateCorrectionsEditorValidation(editorId, validationResult.errors),
                    updateCampaignRateCorrections(campaignId, mapEditorRateCorrectionsToRateCorrections(editorState))
                ];
            } else {
                return [updateRateCorrectionsEditorValidation(editorId, validationResult.errors)];
            }
        })
    );
};

const addEndDateForEditCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ADD_END_DATE_FOR_EDIT_CAMPAIGNS),
        switchMap((action: AddEndDateForEditCampaigns) => {
            const state = store$.value;
            const { campaignId } = action;

            return from(
                getActionsNotificationsDisableValueForNotificationsEditor(
                    state,
                    campaignId,
                    NotificationType.endCampaign,
                    false
                )
            );
        })
    );
};

const deleteEndDateForEditCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(DELETE_END_DATE_FOR_EDIT_CAMPAIGNS),
        switchMap((action: DeleteEndDateForEditCampaigns) => {
            const state = store$.value;
            const { campaignId } = action;

            return from(
                getActionsNotificationsDisableValueForNotificationsEditor(
                    state,
                    campaignId,
                    NotificationType.endCampaign,
                    true
                )
            );
        })
    );
};

const changeSiteMonitoringFlagForEditCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(CHANGE_SITE_MONITORING_FLAG_FOR_EDIT_CAMPAIGNS),
        switchMap((action: ChangeSiteMonitoringFlagForEditCampaigns) => {
            const state = store$.value;
            const { campaignId } = action;
            const campaignValue = getCampaignValue(state, campaignId);
            const { siteMonitoring } = campaignValue;

            return from(
                getActionsNotificationsDisableValueForNotificationsEditor(
                    state,
                    campaignId,
                    NotificationType.monitoringResults,
                    !siteMonitoring
                )
            );
        })
    );
};

const getActionsNotificationsDisableValueForNotificationsEditor = (
    state: State,
    campaignId: string,
    notificationType: NotificationType,
    disableValue: boolean
) => {
    const editorId = getCampaignEditPageEditorId(campaignId);
    const { notificationEditor } = state;
    const currentNotificationEditor = notificationEditor[editorId];
    const notificationsValue = selectCampaignNotificationsValue(state, campaignId);
    const { notifications, phone } = currentNotificationEditor || notificationsValue;
    const indexEndCampaignNotification = findIndex(
        notifications,
        notification => notification.type === notificationType
    );

    if (indexEndCampaignNotification === -1) {
        return EMPTY;
    }

    const actionsList = [
        changeNotificationsDisableValueForEditCampaigns(campaignId, indexEndCampaignNotification, disableValue)
    ];

    if (currentNotificationEditor === undefined) {
        return actionsList;
    }

    if (indexEndCampaignNotification !== undefined && phone !== undefined) {
        return [
            changeNotificationDisableValueForNotificationsEditor(editorId, indexEndCampaignNotification, disableValue),
            ...actionsList
        ];
    } else {
        return EMPTY;
    }
};

const saveCampaignServiceEditorEpic: DnaEpic = (action$, store$) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_SERVICE_EDITOR),
        switchMap(
            (action: SaveCampaignServiceEditor): DnaEpicAction => {
                const { campaignId, service } = action;
                const editorId = getCampaignServiceEditorId(campaignId);
                const errors = validateCampaignService(service);

                if (errors.length) {
                    return of(showErrorsCampaignServiceEditorAction(editorId, errors));
                }

                return [updateCampaignService(campaignId, service), closeCampaignServiceEditorAction(editorId)];
            }
        )
    );
};

const saveCampaignPlaceEditorEpic: DnaEpic = (action$, store$) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_PLACE_EDITOR),
        switchMap(
            (action: SaveCampaignPlaceEditor): DnaEpicAction => {
                const { campaignId, place } = action;
                const editorId = getCampaignPlaceEditorId(campaignId);
                const errors = validateCampaignPlace(place);

                if (errors.length) {
                    return of(showErrorsCampaignPlaceEditorAction(editorId, errors));
                }

                return [updateCampaignPlace(campaignId, place), closeCampaignPlaceEditorAction(editorId)];
            }
        )
    );
};

const saveCampaignStrategyEditorEpic: DnaEpic = (action$, store$) => {
    return action$.pipe(
        ofType(StrategyEditorActionType.VALIDATE_AND_ATTEMPT_SAVE),
        switchMap(
            (action: ValidateAndAttemptSaveAction): DnaEpicAction => {
                const state = store$.value;
                const {
                    commonData: {
                        client: { workCurrency }
                    }
                } = state;

                const { campaignId, strategy } = action;
                const editorId = getCampaignStrategyEditorId(campaignId);
                const campaign = getCampaignData(state, campaignId);
                const metrikaGoals = campaign.availableForKeyGoals;
                const { turboGoalsData } = campaign.strategyGoals;
                const strategyConsts = selectStrategyEditorConstsData(state);

                const validationResult = validateStrategy(
                    workCurrency,
                    metrikaGoals,
                    turboGoalsData,
                    strategy,
                    strategyConsts
                );

                if (!isStrategyValidationResultPositive(validationResult)) {
                    return of(applyStrategyEditorValidationResult(editorId, validationResult));
                }

                const applyActions: Array<Action> = [
                    updateCampaignStrategy(campaignId, mapStrategyForCampaignData(strategy)),
                    closeStrategyEditor(editorId)
                ];

                if (isStrategyNeedsMarkMetrikaLinksEnabled(strategy)) {
                    applyActions.push(updateCampaignMetrikaMarkLinksFlag(campaignId, true));
                    applyActions.push(changeMarkLinksMetrikaCounterEditor(campaignId, true));
                }

                return applyActions;
            }
        )
    );
};

const saveCampaignMinusPhrasesEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_CAMPAIGN_MINUS_PHRASES_EDITOR),
        mergeMap(
            (action: SaveCampaignMinusPhrasesEditor): DnaEpicAction => {
                const { campaignId } = action;
                const state = store$.value;

                const editorId = getCampaignMinusPhrasesEditorId(campaignId);
                const {
                    data: {
                        [editorId]: { minusKeywordsEditor }
                    }
                } = state.minusPhraseLibraryEditor;

                const offset = 0;
                const constants = state.commonData.constants;

                if (!constants) {
                    return EMPTY;
                }

                const limit = constants.minusPhraseLibraryConstants.maxLibraryPacksCount;

                // Заново запросить минус-фразы на случай, если были выбраны удаленные элементы
                return from(deps.minusPhraseLibraryDataProvider.fetchMinusPhraseLibraryData(offset, limit)).pipe(
                    mergeMap((response: FetchMinusPhraseLibraryDataResult): Action[] => {
                        const updatedLibraryItems = mapFetchResultToLibraryItem(response.data);

                        return [
                            updateCampaignMinusPhrases(
                                campaignId,
                                mapMinusPhrasesEditorValueToCampaignMinusPhrasesValue(
                                    minusKeywordsEditor,
                                    updatedLibraryItems || []
                                )
                            ),
                            closeMinusPhrasesEditor(editorId)
                        ];
                    })
                );
            }
        )
    );
};

const saveVisitingCardForEditCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_VISITING_CARD_FOR_EDIT_CAMPAIGN),
        switchMap(
            (action: SaveVisitingCardForEditCampaign): Observable<Action> => {
                const { campaignId } = action;
                const editorId = getCampaignEditPageEditorId(campaignId);

                return of(synchronizeVisitingCardForEditCampaigns(campaignId), closeVCardEditor(editorId));
            }
        )
    );
};

const fetchPricePackagesEditorEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_PRICE_PACKAGES_EDITOR),
        switchMap(
            (action: FetchPricePackagesEditorAction): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login }
                } = state;

                return from(deps.commonDataProvider.fetchClientPricePackages(login)).pipe(
                    map(
                        (response: ApolloQueryResult<PricePackagesAvailableForClient>): Action => {
                            const pricePackages = mapPricePackagesEditorData(response);

                            return updatePricePackagesForCampaignsEdit(pricePackages);
                        }
                    ),
                    catchError(() => EMPTY)
                );
            }
        )
    );
};

const updateFieldsByPricePackageEditCampaignEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(CHANGE_CAMPAIGN_PRICE_PACKAGE_FOR_CAMPAIGNS_EDIT),
        switchMap(
            (action: ChangeCampaignPricePackageForEditCampaign): Observable<Action> => {
                const state = store$.value;
                const { campaignId, pricePackageId } = action;
                const pricePackage = selectPricePackageDataForEditCampaigns(state, pricePackageId);

                if (!pricePackage) {
                    return EMPTY;
                }

                return of(
                    updateDatesIntervalEditors({
                        [campaignId]: mapDateEditorsDataFromPackageForCampaigns(pricePackage)
                    })
                );
            }
        )
    );
};

const saveExperimentsConditionsForEditCampaignRequest = (
    state: State,
    deps: EpicDeps,
    experimentsConditionsItems: GdCreateRetargetingConditionForExperimentsItemInput[]
): Promise<FetchResult<FindOrCreateExperimentsConditions> | undefined> => {
    const {
        commonData: { login }
    } = state;

    if (experimentsConditionsItems.length === 0) {
        return Promise.resolve(undefined);
    }

    return deps.campaignsMutationExecutor.findOrCreateExperimentsConditions(experimentsConditionsItems, login);
};

const saveExperimentsConditionsForEditCampaignErrorExecutor = (
    validationResult: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult,
    campaignsIdsWithEnabledExperiments: string[],
    experimentsConditionsItems: GdCreateRetargetingConditionForExperimentsItemInput[]
): DnaEpicAction => {
    const experimentsConditionsErrorMapper = createExperimentsConditionsErrorMapper(campaignsIdsWithEnabledExperiments);

    const experimentsConditionsValidationData = experimentsConditionsErrorMapper.mapServerErrorsToClientError(
        validationResult.errors
    ) as ExperimentsConditionsValidationData;

    const updateArchivedExperimentsInput = mapExperimentsConditionValidationDataToUpdateArchivedExperimentsInput(
        experimentsConditionsValidationData,
        campaignsIdsWithEnabledExperiments,
        experimentsConditionsItems
    );

    return [
        updateCampaignArchivedExperiments(updateArchivedExperimentsInput),
        ...updateArchivedExperimentsInput.map(input => {
            return updateArchivedMapExperimentsEditor(
                getCampaignExperimentsEditorId(input.campaignId),
                input.archivedExperimentsIds
            );
        }),
        changeCampaignsEditPageStatus(PageStatus.LOADED)
    ];
};

const saveExperimentsConditionsForEditCampaignSuccessExecutor = (
    campaignIds: string[],
    items: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_addedConditions[]
): DnaEpicAction => {
    return [updateCampaignExperimentsRetargetingConditions(mapCreateExperimentsConditionsResult(campaignIds, items))];
};

const fetchMetrikaGoalsForStrategyEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_CAMPAIGN_GOALS_FOR_STRATEGY),
        switchMap(
            (action: FetchCampaignGoalsForStrategyAction): Observable<SetMetrikaGoalsDataForStrategyAction> => {
                const {
                    commonData: { login },
                    metrikaCounterEditor: { counters }
                } = store$.value;
                const { isCreatePage } = action;
                const availableCountersSet = new Set(counters);
                const campaignIds = Object.keys(action.metrikaCountersByCampaignId);

                return forkJoin(
                    ...campaignIds.map(campaignId =>
                        deps.campaignsMutationExecutor.getOrCreateMetrikaGoalsForCampaignByCounter(
                            login,
                            action.metrikaCountersByCampaignId[campaignId].filter(counter =>
                                availableCountersSet.has(counter)
                            ),
                            isCreatePage ? undefined : campaignId
                        )
                    )
                ).pipe(
                    map(fetchResults => fetchResults.map(mapStrategyGoalsFromApiResponse)),
                    map(
                        (
                            metrikaGoalsData: Array<
                                [Record<string, GoalForStrategy>, Record<string, GoalForStrategy>, boolean]
                            >
                        ) =>
                            setMetrikaGoalsDataForStrategy(
                                mapStrategyGoalsDataForReducer(campaignIds, metrikaGoalsData)
                            )
                    ),
                    catchError((err: Error | ApiMethodExecutingError) => {
                        const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                        try {
                            fireCampaignsEditMetrika({
                                fetchCampaignGoalsForStrategy: {
                                    error: message
                                }
                            });
                        } catch (e) {
                            // do nothing
                        }

                        return of(setMetrikaGoalsDataForStrategy(mapStrategyGoalsDataForReducer(campaignIds, [])));
                    })
                );
            }
        )
    );
};

const getCommonActionsForInitEditCampaignPage = (
    campaignsForEditData: DataForEditCampaigns,
    enabledFieldsAtLeastOneCampaign: EnabledFieldsMap
): Action[] => {
    return compact([
        ...initCampaignsEditors(campaignsForEditData, enabledFieldsAtLeastOneCampaign),
        updateDataForEditCampaigns(campaignsForEditData),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.pricePackageId] && fetchPricePackagesEditor(),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.metrikaCounters] && fetchCountersMetrikaCounterEditor(),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.visitingCard] &&
            fetchMetroStationsForEditCampaigns(mapCampaignsIdsToFetchVisitingCardInput(campaignsForEditData.campaigns)),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.chatOperator] && fetchChatsChatListEditor(),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.timeTargeting] && fetchTimeZoneGroups()
    ]);
};

const getActionsForInitEditCampaignsPage = (
    campaignsForEditData: DataForEditCampaigns,
    enabledFieldsAtLeastOneCampaign: EnabledFieldsMap
): Action[] => {
    return compact([
        ...getCommonActionsForInitEditCampaignPage(campaignsForEditData, enabledFieldsAtLeastOneCampaign),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.experiments] &&
            fetchCampaignABSegments(
                mapCampaignsToFetchGoalsInput(campaignsForEditData.campaigns, EditCampaignValueField.experiments)
            ),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.metrikaKeyGoals] &&
            fetchCampaignsGoalsAvailableForKeyGoals(
                mapCampaignsToFetchGoalsInput(campaignsForEditData.campaigns, EditCampaignValueField.metrikaKeyGoals)
            ),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.relevantPhrases] &&
            fetchRelevantPhrasesGoalsForEditCampaigns(
                mapCampaignsIdsToFetchBroadMatchGoalsInput(campaignsForEditData.campaigns)
            )
    ]);
};

const getActionsForInitCreateCampaignsPage = (
    campaignsForEditData: DataForEditCampaigns,
    enabledFieldsAtLeastOneCampaign: EnabledFieldsMap
): Action[] => {
    const { campaigns } = campaignsForEditData;
    const campaignsIds = Object.keys(campaigns);

    return compact([
        ...getCommonActionsForInitEditCampaignPage(campaignsForEditData, enabledFieldsAtLeastOneCampaign),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.experiments] &&
            updateCampaignABSegmentsSuccess(campaignsIds),
        enabledFieldsAtLeastOneCampaign[EditCampaignValueField.metrikaKeyGoals] &&
            updateCampaignAvailableForKeyGoals(
                true,
                campaignsIds.map(campaignId => {
                    return {
                        campaignId,
                        goals: {}
                    };
                })
            ),
        ...getActionsInitializationOpeningEditorsForCreateCampaigns(
            campaignsForEditData,
            enabledFieldsAtLeastOneCampaign
        )
    ]);
};

const getActionsInitializationOpeningEditorsForCreateCampaigns = (
    campaignsForEditData: DataForEditCampaigns,
    enabledFieldsAtLeastOneCampaign: EnabledFieldsMap
): Action[] => {
    return values(campaignsForEditData.campaigns).reduce((actionsList: Action[], campaign) => {
        const {
            id,
            value: { name }
        } = campaign;

        return actionsList.concat(
            compact([
                enabledFieldsAtLeastOneCampaign[EditCampaignValueField.name] &&
                    openEditPageItemNameEditor(getCampaignEditPageEditorId(id), name),
                enabledFieldsAtLeastOneCampaign[EditCampaignValueField.strategy] &&
                    openStrategyEditor(getCampaignStrategyEditorId(id))
            ])
        );
    }, []);
};

const getDefaultCampaignsForEditEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_DEFAULT_CAMPAIGNS_FOR_EDIT),
        awaitCommonData(action$, store$),
        switchMap(
            (action: GetDefaultCampaignsForEditAction): DnaEpicAction => {
                const state = store$.value;
                const {
                    commonData: { login, accessRights }
                } = state;

                if (
                    !accessRights.canCreateCampaign ||
                    !accessRights.canCreateCampaignTypes.includes(
                        mapCampaignTypeTypeToApiCampaignType(action.campaignType)
                    )
                ) {
                    return of(leaveCampaignsEdit(UrlHelpers.getCampaignListUrl(), false));
                }

                return from(deps.campaignsDataProvider.getDefaultCampaignsEditQuery(login, action.campaignType)).pipe(
                    switchMap(
                        (response): DnaEpicAction => {
                            const {
                                commonData: { constants },
                                editCampaigns: { campaignType }
                            } = state;
                            if (constants === undefined) {
                                throw new Error('отсутсвует поле constants в commonData');
                            }
                            if (campaignType === undefined) {
                                throw new Error('не указан тип создаваемой кампании');
                            }
                            const campaignsForEditData = mapDefaultCampaignsQueryResultToQueryResponse(
                                response,
                                constants,
                                selectClientFeatures(state),
                                campaignType
                            );
                            const enabledFieldsAtLeastOneCampaign = getEnabledFieldsFromAtLeastOneCampaign(
                                campaignsForEditData.campaigns
                            );

                            return getActionsForInitCreateCampaignsPage(
                                campaignsForEditData,
                                enabledFieldsAtLeastOneCampaign
                            );
                        }
                    ),
                    catchError(
                        (err: Error | ApiMethodExecutingError): DnaEpicAction => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            return of(
                                showCampaignEditGlobalError({
                                    title: i18n('page-common-error'),
                                    hint: message || i18n('page-common-error-hint')
                                })
                            );
                        }
                    )
                );
            }
        )
    );
};

const strategyEditorSelectRoiByMeaningfulGoalsEpic: DnaEpic = action$ => {
    return action$.pipe(
        ofType(StrategyEditorActionType.CHANGE_GOAL_ID),
        filter(({ goalId }: ChangeStrategyGoalIdAction): boolean => {
            return goalId === AdditionalGoalIds.allMeaningfulGoals;
        }),
        first(),
        mapTo(hideRoiMeaningfulGoalsTooltip())
    );
};

const strategyEditorHideRoiMeaningfulGoalsTooltipEpic: DnaEpic = action$ => {
    return action$.pipe(
        ofType(StrategyEditorActionType.HIDE_ROI_MEANINGFUL_GOALS_TOOLTIP),
        first(),
        mergeMap(() => {
            setRoiMeaningfulGoalsTooltipHidden();

            return EMPTY;
        })
    );
};

const fetchMetroStationsForEditCampaignsEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_METRO_STATIONS_FOR_EDIT_CAMPAIGNS),
        mergeMap(
            (action: FetchMetroStationsForEditCampaigns): Observable<Action> => {
                const { campaignsIds } = action;

                return from(deps.commonDataProvider.getMetroStations()).pipe(
                    mergeMap((metroStations: Record<number, Array<MetroStationInfo>>) => {
                        return of(
                            updateMetroStations(metroStations),
                            updateMetroStationsNameForEditCampaigns(metroStations, campaignsIds)
                        );
                    }),
                    catchError(
                        (err: Error | ApiMethodExecutingError): Observable<Action> => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            try {
                                fireCampaignsEditMetrika({
                                    getMetroStations: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            return of(
                                showCampaignEditGlobalError({
                                    title: i18n('page-common-error'),
                                    hint: message || i18n('page-common-error-hint')
                                })
                            );
                        }
                    )
                );
            }
        )
    );
};

const fetchRelevantPhrasesGoalsForEditCampaignsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(FETCH_RELEVANT_PHRASES_GOALS_FOR_EDIT_CAMPAIGNS),
        mergeMap(
            (action: FetchRelevantPhrasesGoalsForEditCampaigns): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login }
                } = state;
                const { campaignsIds } = action;

                return from(deps.campaignsDataProvider.getBroadMatchGoals(login, campaignsIds)).pipe(
                    mergeMap((broadMatchGoalsQuery: ApolloQueryResult<BroadmatchGoalsQuery>) => {
                        return of(
                            updateRelevantPhrasesGoalsForEditCampaigns(
                                broadMatchGoalsQuery.data.client.broadMatchGoals,
                                campaignsIds
                            )
                        );
                    }),
                    catchError(
                        (err: Error | ApiMethodExecutingError): Observable<Action> => {
                            const message = err instanceof ApiMethodExecutingError ? err.getMessage() : err.message;

                            try {
                                fireCampaignsEditMetrika({
                                    getBroadMatchGoals: {
                                        error: message
                                    }
                                });
                            } catch (e) {
                                // do nothing
                            }

                            return of(
                                showCampaignEditGlobalError({
                                    title: i18n('page-common-error'),
                                    hint: message || i18n('page-common-error-hint')
                                })
                            );
                        }
                    )
                );
            }
        )
    );
};

export const campaignsEditEpic = combineEpics(
    getCampaignsForEditEpic,
    fetchCampaignsGoalsAvailableForKeyGoalsEpic,
    fetchCampaignABSegmentsEpic,
    saveCampaignChatEpic,
    startSaveCampaignsEpic,
    saveCampaignsEpic,
    leaveCampaignsEditEpic,
    getRetargetingConditionsForCampaignsEditEpic,
    saveCampaignRelevantPhrasesEpic,
    saveCampaignMetrikaCountersEpic,
    updateCampaignMetrikaCountersEpic,
    updateCampaignNameEpic,
    saveCampaignNotificationEditorEpic,
    saveCampaignTimeTargetingEditorEpic,
    updateCampaignDisabledIpsEpic,
    updateCampaignBannedDomainsEpic,
    updateCampaignAllowedPageIdsEpic,
    saveCampaignExperimentsEditorEpic,
    saveCampaignMetrikaKeyGoalsEditorEpic,
    saveCampaignRateCorrectionEditorEpic,
    addEndDateForEditCampaignEpic,
    deleteEndDateForEditCampaignEpic,
    changeSiteMonitoringFlagForEditCampaignEpic,
    saveCampaignServiceEditorEpic,
    saveCampaignPlaceEditorEpic,
    saveCampaignStrategyEditorEpic,
    saveCampaignMinusPhrasesEditorEpic,
    saveVisitingCardForEditCampaignEpic,
    fetchMetrikaGoalsForStrategyEditorEpic,
    strategyEditorHideRoiMeaningfulGoalsTooltipEpic,
    strategyEditorSelectRoiByMeaningfulGoalsEpic,
    createCampaignsEpic,
    getDefaultCampaignsForEditEpic,
    fetchCampaignABSegmentsForNewCampaignEpic,
    fetchGoalsAvailableForKeyGoalsForNewCampaignsEpic,
    updateFieldsByPricePackageEditCampaignEpic,
    fetchPricePackagesEditorEpic,
    fetchMetroStationsForEditCampaignsEpic,
    fetchRelevantPhrasesGoalsForEditCampaignsEpic,
    updateCampaignBannedVideoDomainsEpic
);
